import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'

const StyledWrapper = styled.section`
  background-color: ${ ({ theme }) => theme.colors.black } ;
  color: ${ ({ theme }) => theme.colors.white } ;
  padding-bottom: 30px;
  padding-top: 40px;

  ${ media.tablet`
    padding-top: 80px;
    padding-bottom: 80px;
  ` }

  ${ media.desktop`
    padding-top: 100px;
    padding-bottom: 100px;
  ` }
`

const StyledContainer = styled(ArBaseContainer)`

`

const StyledList = styled.ul`
  ${ media.desktop`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  ` }
`

const StyledItem = styled.li`
  text-align: center;

  ${ media.tablet`
    text-align: left;
  ` }

  ${ media.desktop`
    width: calc(50% - 40px);
    max-width: 520px;
  ` }

  & + & {
    border-top: 1px solid ${ ({ theme }) => theme.colors.white20p } ;
    margin-top: 30px;
    padding-top: 40px;

    ${ media.tablet`
      margin-top: 80px;
      padding-top: 80px;
    ` }

    ${ media.desktop`
      margin-top: 0;
      padding-top: 0;
      border: none;
    ` }
  }
`

const StyledImage = styled(ArBaseImage)`
  display: inline-block;
  margin-bottom: 20px;
  height: 40px; /* TODO: To achieve sizes like on designs > sizes needs to be setted in CMS */

  ${ media.tablet`
    margin-bottom: 30px;
  ` }
`

const StyledDescription = styled.p`
  font-size: 1.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light } ;
  line-height: 1.44;
  margin-bottom: 10px;

  ${ media.tablet`
    margin-bottom: 30px;
    line-height: 1.46;
    font-size: 2.8rem;
  ` }
`

const StyledName = styled.p`
  font-size: 1.8rem;
  letter-spacing: 0.01em;
  line-height: 1.55;
`

const StyledPosition = styled.p`
  color: ${ ({ theme }) => theme.colors.white } ;
  font-size: 1.8rem;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light } ;
  line-height: 1.44;
  margin-top: 5px;
  ${ media.tablet`
    color: ${ ({ theme }) => theme.colors.accent } ;
    font-family: ${ ({ theme }) => theme.font.secondary };
    font-size: 1.4rem;
    letter-spacing: 0.01em;
    line-height: 1.55;
  ` }
`

class ArTestimonials extends React.Component {
  static propTypes = {
    testimonials: PropTypes.array,
  }

  render () {
    const { testimonials } = this.props

    return (
      <StyledWrapper>
        <StyledContainer>
          <StyledList>
            {testimonials.map(({ image, description, name, position }, index) =>
              <StyledItem key={index}>
                <StyledImage src={image.url}></StyledImage>
                <StyledDescription>{ description }</StyledDescription>
                <StyledName>{ name }</StyledName>
                <StyledPosition>{ position }</StyledPosition>
              </StyledItem>
            )}
          </StyledList>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default ArTestimonials
